import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core';

// const SERVER = 'http://localhost:3000/api/cookie'
const SERVER = '/api/cookie'

// Model
export interface CookieText {
    cookie: string;
}

@Injectable()
export class CookieService {

    constructor (private http: HttpClient) {}

    async getCookies(c: number = 1 ): Promise<CookieText[]> {

        // query string        
        const params = new HttpParams().set('count',`${c}`)

        // construct the call
        // GET /api/cookie?count=c
        const resp = await this.http.get<any>(SERVER, { params } )
            .toPromise()

        if (c == 1)
            return [resp as CookieText ]
        return resp as CookieText[]
    }

}
